const deviceGroupNames = {
  charger: "charger",
  holder: "holder",
  mono: "mono"
};

export default deviceGroupNames;
